import React from 'react'

const Tag = ({ tag }) => {
  if (tag.toLowerCase() === "lunas") {
    return <span className='font-inter rounded-[4px] px-[16px] py-[2px] text-white bg-green-2 text-[12px] font-medium leading-[18px]'>{tag}</span>
  }
  return <span className='font-inter rounded-[4px] px-[16px] py-[2px] text-black-0  text-[12px] bg-yellow-1 font-medium leading-[18px]'>{tag}</span>
}

export default Tag